import ChatPage from './Chat';

/**
 * 移动端入口复用同一套真实问答组件；响应式样式负责收窄为单栏。
 * 因而桌面端的 SSE、证据审计和安全打字机效果会在手机上保持一致。
 */
export default function MobilePage() {
  return <ChatPage />;
}
